import {
	Directive, ElementRef, Renderer2, AfterViewInit
} from '@angular/core';

import styles from './vb-ui-error-message.module.less';
@Directive({
	selector: '[vbUiErrorMessage]',
	host: {
		'[class]': 'styles.errorMessage',
		'attr.role': 'alert'
	},
	standalone: false
})
export class VbUiErrorMessageAngularDirective implements AfterViewInit {
	public readonly styles = styles;
	constructor(
		private readonly el: ElementRef,
		private readonly renderer: Renderer2
	) {}

	public ngAfterViewInit(): void {
		const span = this.renderer.createElement('span');
		const firstChild = (this.el.nativeElement as HTMLElement).firstChild;
		this.renderer.addClass(span, 'glyphicons');
		this.renderer.addClass(span, 'circle_exclamation_mark');
		this.renderer.addClass(span, this.styles.errorIcon);
		this.renderer.insertBefore(this.el.nativeElement, span, firstChild);
	}
}
